import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import type { AdPartner, AdPartnerBlueprint } from '../../../../main/types/adPartnerTypes';
import { AdPartnerService } from '../../../services/AdPartner.service';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const GetAdPartnerForOrg = new ReduxAsyncAction<'AD_PARTNER_GET_PARTNER_FOR_ORG', string, AdPartner>(
  'AD_PARTNER_GET_PARTNER_FOR_ORG'
);

GetAdPartnerForOrg.registerRequest(async (machine_name) => {
  const { data: orgConfig } = await dash_api.get<AdPartner>(`/v1/ad-networks/org/${machine_name}`);
  const { data } = await dash_api.get<AdPartnerBlueprint>(`/v1/ad-networks/global-org/${machine_name}`);
  return AdPartnerService.mergeEntityWithBlueprint(data, orgConfig);
});

export const GET_PARTNER_FOR_ORG = GetAdPartnerForOrg.actionNamespaceConstants;

export const getAdPartnerForOrg = GetAdPartnerForOrg.request;

export type GetAdPartnerForOrgResponseAction = Action<typeof GET_PARTNER_FOR_ORG.response> & { data: AdPartner };
